var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmbr2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 75,
    viewBox: "0 0 94 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 37.5C88 54.897 73.897 69 56.5 69C39.103 69 25 54.897 25 37.5C25 20.103 39.103 6 56.5 6C73.897 6 88 20.103 88 37.5Z",
    fill: "white",
    stroke: "#2C4245",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2525 50.68H65.0605V46.968H55.6205C59.3325 43.832 64.5485 39.608 64.5485 34.2C64.5485 30.136 62.0205 27.16 56.9965 27.16C52.8045 27.16 49.3805 29.624 49.2205 34.968H53.5725C53.6045 32.504 54.7885 30.968 56.9325 30.968C59.1405 30.968 60.0685 32.376 60.0685 34.456C60.0685 38.744 54.5325 42.872 49.2525 47.352V50.68Z",
    fill: "#32474A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 39.732C1.66667 38.9622 1.66667 37.0378 3 36.268L22.5 25.0096C23.8333 24.2398 25.5 25.2021 25.5 26.7417L25.5 49.2583C25.5 50.7979 23.8333 51.7602 22.5 50.9904L3 39.732Z",
    fill: "#2C4245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmbr2);
export default __webpack_public_path__ + "static/media/nmbr2.665e71407047eabfee5124abd51ada84.svg";
export { ForwardRef as ReactComponent };